import React from "react";
import CheckboxItemLayout from "./checkbox-item-layout";

export default class CheckboxItemScreen extends React.Component<any, {}> {
  render() {
    const {
      className,
      name,
      checked,
      onChange,
      showError,
      checkboxText,
      errorText,
      withTab,
      disabled
    } = this.props;
    return (
      <CheckboxItemLayout
        className={className}
        name={name}
        checked={checked}
        onChange={(ev: React.ChangeEvent<HTMLInputElement>) => onChange(ev)}
        checkboxText={checkboxText}
        errorText={errorText}
        showError={showError}
        withTab={withTab}
        disabled={disabled}
      />
    );
  }
}
